<div class="content">
  <h2>Cards</h2>

  @if (cardsLoading$ | async) {
    <mat-spinner></mat-spinner>
  }

  <div class="order-cards">
    @for (card of cards$ | async; track card.id) {
      <div
        class="card-preview card"
        [ngClass]="{ selected: (currentCard$ | async)?.id == card.id }">
        <p class="label">
          <strong>{{ card.label }} (#C_{{ card.id }})</strong>
        </p>
        <img (click)="setCurrentCard(card)" [src]="card.frontImageURL" />
      </div>
    }
  </div>

  @if ((currentCard$ | async) != null) {
    @if ((cards$ | async)!.length > 1) {
      <div class="pagination" id="pagination">
        <button
          mat-flat-button
          color="primary"
          [disabled]="
            !(hasPrevCard$ | async) || (saving$ | async) || unsavedChanges()
          "
          (click)="prevCard()">
          Previous Card
        </button>
        <button
          mat-flat-button
          color="primary"
          [disabled]="
            !(hasNextCard$ | async) || (saving$ | async) || unsavedChanges()
          "
          (click)="nextCard()">
          Next Card
        </button>
      </div>
    }

    <div class="card-editor" id="editor">
      <div class="section">
        <h2>Images</h2>
        <div class="images">
          <img
            [src]="(currentCard$ | async)!.frontImageURL"
            (click)="handleImageClick(false)"
            width="200"
            alt="Card Front" />
          <img
            [src]="(currentCard$ | async)!.backImageURL"
            (click)="handleImageClick(true)"
            width="200"
            alt="Card Back" />
        </div>
      </div>

      <div class="section">
        <div class="row space-between">
          <h2>Details</h2>
          @if (saving$ | async) {
            <p>Saving...</p>
          } @else if (unsavedChanges()) {
            <p>Unsaved Changes</p>
          } @else {
            <p>Saved</p>
          }
        </div>
        <mat-tab-group
          (selectedIndexChange)="selectedIndexChanged($event)"
          [selectedIndex]="currentTabIndex$ | async">
          <mat-tab label="Attributes">
            @if ((currentTabIndex$ | async) == 0) {
              @if (aiLoading$ | async) {
                <div class="ai-loading">
                  <p>Detecting Attributes</p>
                  <mat-spinner></mat-spinner>
                </div>
              }

              @if (!(hideForm$ | async)) {
                <form [formGroup]="form">
                  <formly-form [form]="form" [fields]="fields" [model]="model">
                  </formly-form>
                </form>
              } @else {
                <div class="form-loader"></div>
              }

              <div class="actions">
                <!-- <button mat-flat-button color="warn" (click)="cancel()">
                  Cancel
                </button> -->
                <button
                  mat-flat-button
                  color="primary"
                  [disabled]="!form.valid || !form.dirty"
                  (click)="save()">
                  Save
                </button>
                <!-- <button
                  mat-flat-button
                  color="primary"
                  [disabled]="!form.valid || !form.dirty"
                  (click)="saveAndSend()">
                  Save & Send
                </button> -->
              </div>
            }
          </mat-tab>
          <mat-tab label="Chat">
            @if ((currentTabIndex$ | async) == 1) {
              <aa-chat [orderCardId]="(currentCard$ | async)!.id"></aa-chat>
            }
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  }
</div>
